import type { ReactNode } from 'react';
import { BetSlip } from '../BetSlip/BetSlip';
import { Footer } from '../Footer/Footer';
import { LeftSidebar } from '../Sidebar/LeftSidebar';
import type { BetSelection } from '../../types/domain';

interface AppShellProps {
  children: ReactNode;
  sportsLayout: boolean;
  selections: BetSelection[];
  onRemove: (oddId: string) => void;
  onClear: () => void;
  onRegister: () => void;
}

export function AppShell({ children, sportsLayout, selections, onRemove, onClear, onRegister }: AppShellProps) {
  return (
    <div className={`app-layout${sportsLayout ? ' app-layout--sports' : ' app-layout--wide'}`}>
      {sportsLayout && <LeftSidebar />}
      <main className="main-content" id="main-content">{children}</main>
      {sportsLayout && <BetSlip selections={selections} onRemove={onRemove} onClear={onClear} onRegister={onRegister} />}
      <div className="app-layout__footer"><Footer /></div>
    </div>
  );
}
